<template>
  <div style="display: flex; flex-direction: column; height: 100%; width: 100%; user-select: none; cursor: default;">
    <v-data-table 
      :headers="display.CRMWhatsappConversationFeedbackHeaders.sort((a, b) => a.index - b.index)" 
      :items="display.CRMWhatsappConversationFeedbacks" 
      :items-per-page="-1"
      :loading="loader.selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent"
      loading-text=""
      fixed-header
      hover
      style="flex: 1; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;"
    >
      <template v-slot:headers="{ columns }">
        <tr>
          <th v-for="column in columns" :key="column.key">
            <v-card color="primary" elevation="0" rounded="0" style="display: flex; align-items: center; white-space: nowrap; height: 100%; width: 100%; padding: 0px 25px;">
              <template v-if="!loader.getSystemInformation">
                <v-icon v-if="display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == column.key).index > 0" @click="updateCRMWhatsappConversationFeedbackHeadersIndex(column.key, -1)" color="secondary" size="x-small" class="hoverableElement" style="margin-right: 10px">mdi-arrow-left-bold</v-icon>
                <template v-if="column.key == 'CRMWhatsappConversationFeedbackSelectAction'">
                  <v-checkbox-btn 
                    v-model="input.allCRMWhatsappConversationFeedbackSelected" 
                    @update:model-value="display.CRMWhatsappConversationFeedbacks.forEach(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.selectedCRMWhatsappConversationFeedback = input.allCRMWhatsappConversationFeedbackSelected)"
                    color="indigo" 
                    density="compact" 
                    hide-details>
                  </v-checkbox-btn>
                </template>
                <template v-else>
                  <v-icon color="indigo" style="margin-right: 5px;">{{ display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == column.key).icon }}</v-icon>
                  <span v-if="display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == column.key).visibility" style="margin-right: 5px; display: flex; align-items: center;"><strong>{{ display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == column.key).title }}</strong></span>
                  <v-icon @click="display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == column.key).visibility = !display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == column.key).visibility; updateCRMWhatsappConversationFeedbackHeadersVisibility()" color="secondary" size="x-small" class="hoverableElement">mdi-{{ display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == column.key).visibility ? 'eye' : 'eye-off' }}</v-icon>
                </template>
                <v-icon v-if="display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == column.key).index < display.CRMWhatsappConversationFeedbackHeaders.length - 1" @click="updateCRMWhatsappConversationFeedbackHeadersIndex(column.key, 1)" color="secondary" size="x-small" class="hoverableElement" style="margin-left: 10px">mdi-arrow-right-bold</v-icon>  
              </template>
            </v-card>
          </th>
        </tr>
      </template>
      <template v-slot:item="row">
        <tr :class="row.item.loadingCRMWhatsappConversationFeedback ? 'loadingVDataTableRow' : (row.item.appearingCRMWhatsappConversationFeedback ? 'appearingVDataTableRow' : (row.item.selectedCRMWhatsappConversationFeedback ? 'selectedVDataTableRow' : (loader.selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentPagination ? 'loadingVDataTableRow' : null)))">
          <template v-for="header in display.CRMWhatsappConversationFeedbackHeaders.sort((a, b) => a.index - b.index)" :key="header.value">
            <td :class="header.value != 'CRMWhatsappConversationFeedbackSelectAction' && computed_selectedCRMWhatsappConversationFeedbackCount > 0 && !row.item.selectedCRMWhatsappConversationFeedback ? 'bluredVDataTableRow' : null">
              <template v-if="header.value == 'CRMWhatsappConversationFeedbackID' && header.visibility">
                <v-hover>
                  <template v-slot="{ isHovering, hoverProps }">
                    <template v-if="isHovering == true && !systemInformationData.tooltipDisabled">
                      <v-tooltip v-bind="hoverProps" text="Copiar ID al portapapeles" location="top">
                        <template v-slot:activator="{ props: tooltipProps }">
                          <p v-bind="tooltipProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID del feedback', 'o', row.item.CRMWhatsappConversationFeedbackID)" class="hoverableElement" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappConversationFeedbackID }}</strong></p>
                        </template>
                      </v-tooltip>
                    </template>
                    <template v-else>
                      <p v-bind="hoverProps" @click="$generalFunctions.default.copyToClipboard(this, 'ID del feedback', 'o', row.item.CRMWhatsappConversationFeedbackID)" class="hoverableElement" style="color: #3F51B5;"><strong>{{ row.item.CRMWhatsappConversationFeedbackID }}</strong></p>
                    </template>
                  </template>
                </v-hover>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappContactID' && header.visibility">
                <p style="white-space: nowrap;">{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                <p style="font-size: small; color: #9e9e9e; white-space: nowrap;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackCreationDatetime' && header.visibility">
                <p style="white-space: nowrap;">{{ $displayFunctions.default.fromDatetimeToHHMMSSDDMMYYYY(row.item.CRMWhatsappConversationFeedbackCreationDatetime) }}</p>
              </template>
              <template v-else-if="header.value == 'CRMAgentID' && header.visibility">
                <template v-if="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMAgentID)">
                  <v-chip :color="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMAgentID).CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMAgentID).CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>{{ systemInformationData.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == row.item.CRMAgentID).CRMAgentName || 'No registrado' }}</p>
                    </div>
                  </v-chip>
                </template>
                <template v-else>
                  <v-chip color="primary" variant="flat" label>
                    <div style="display: flex; align-items: center;">
                      <img :src="require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" :draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                      <p>No registrado</p>
                    </div>
                  </v-chip>
                </template>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackOne' && header.visibility">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <v-icon v-for="i in 5" :key="i" color="indigo" size="small">{{ i <= row.item.CRMWhatsappConversationFeedbackOne ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                </div>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackTwo' && header.visibility">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <v-icon v-for="i in 5" :key="i" color="indigo" size="small">{{ i <= row.item.CRMWhatsappConversationFeedbackTwo ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                </div>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackThree' && header.visibility">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <v-icon v-for="i in 5" :key="i" color="indigo" size="small">{{ i <= row.item.CRMWhatsappConversationFeedbackThree ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                </div>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackFour' && header.visibility">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <v-icon v-for="i in 5" :key="i" color="indigo" size="small">{{ i <= row.item.CRMWhatsappConversationFeedbackFour ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                </div>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackTotal' && header.visibility">
                <div style="display: flex; align-items: center; justify-content: center;">
                  <v-icon v-for="i in 5" :key="i" color="indigo" size="small">{{ i <= Math.floor((row.item.CRMWhatsappConversationFeedbackOne + row.item.CRMWhatsappConversationFeedbackTwo + row.item.CRMWhatsappConversationFeedbackThree + row.item.CRMWhatsappConversationFeedbackFour) / 4) ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>
                </div>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackSeven' && header.visibility">
                <p style="max-width: 400px; max-height: 200px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">{{ row.item.CRMWhatsappConversationFeedbackSeven }}</p>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackSix' && header.visibility">
                <v-menu :close-on-content-click="false" :open-on-hover="true" :scrim="true" style="user-select: none; cursor: default;">
                  <template v-slot:activator="{ props }">
                    <v-btn 
                      v-bind="props"
                      v-if="row.item.CRMWhatsappConversationFeedbackSix && /\S/.test(row.item.CRMWhatsappConversationFeedbackSix)"
                      :disabled="row.item.loadingCRMWhatsappConversationFeedback || row.item.appearingCRMWhatsappConversationFeedback || (computed_selectedCRMWhatsappConversationFeedbackCount > 0 && !row.item.selectedCRMWhatsappConversationFeedback)"
                      color="primary" 
                      class="hoverableText" 
                    >
                      <v-icon size="small" style="margin-right: 10px;">mdi-comment</v-icon>
                      <p style="font-size: small;">COMENTARIO</p>
                    </v-btn>
                  </template>
                  <v-card style="padding: 10px; max-width: 500px; min-width: 400px; max-height: 400px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
                    <div style="display: flex;">
                      <div>
                        <p>{{ $displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item) }}</p>
                        <p style="font-size: small; color: #9e9e9e;">{{ $displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false) }}</p>
                      </div>
                      <div style="margin-left: auto;">
                        <v-icon color="indigo" class="hoverableElement" @click="$generalFunctions.default.copyToClipboardWithoutTitle(this, 'Feedback de la conversación', 'o', `${$displayFunctions.default.parseCRMWhatsappContactNameToDisplay(row.item)}\n${$displayFunctions.default.fromPhoneNumberToCountryCodePhoneNumberCountryFlag(row.item.CRMWhatsappContactPhoneNumber, false)}\n\n${row.item.CRMWhatsappConversationFeedbackSix}`)">mdi-content-copy</v-icon>
                      </div>
                    </div>
                    <v-divider color="indigo" style="margin: 10px 0;"></v-divider>
                    <p style="font-size: small; font-style: italic;">"{{ row.item.CRMWhatsappConversationFeedbackSix }}"</p>
                  </v-card>
                </v-menu>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackAction' && header.visibility">
                <v-btn 
                  @click="$root.dialogComponent.openCRMWhatsappConversationDialog(row.item.CRMWhatsappConversationID, true, false, false, true, true, true, false, false, false, false, true, false)" 
                  :disabled="row.item.loadingCRMWhatsappConversationFeedback || row.item.appearingCRMWhatsappConversationFeedback || (computed_selectedCRMWhatsappConversationFeedbackCount > 0 && !row.item.selectedCRMWhatsappConversationFeedback)"
                  color="primary" 
                  class="hoverableText"
                >
                  <v-icon size="small" style="margin-right: 10px;">mdi-chat</v-icon>
                  <p style="font-size: small;">CONVERSACIÓN</p>
                </v-btn>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackResumeAction' && header.visibility">
                <v-btn 
                  @click="$root.dialogComponent.openResumeCRMWhatsappConversationDialog(row.item.CRMWhatsappConversationID)" 
                  :disabled="row.item.loadingCRMWhatsappConversationFeedback || row.item.appearingCRMWhatsappConversationFeedback || (computed_selectedCRMWhatsappConversationFeedbackCount > 0 && !row.item.selectedCRMWhatsappConversationFeedback)"
                  color="primary" 
                  class="hoverableText"
                >
                  <v-icon size="small" style="margin-right: 10px;">mdi-chat-plus</v-icon>
                  <p style="font-size: small;">RETOMAR</p>
                </v-btn>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackSelectAction' && header.visibility">
                <v-checkbox-btn 
                  v-model="row.item.selectedCRMWhatsappConversationFeedback" 
                  @update:model-value="input.allCRMWhatsappConversationFeedbackSelected = display.CRMWhatsappConversationFeedbacks.every(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.selectedCRMWhatsappConversationFeedback)"
                  color="indigo" 
                  density="compact"
                  hide-details
                  class="hoverableText"
                >
                </v-checkbox-btn>
              </template>
              <template v-else-if="header.value == 'CRMWhatsappConversationFeedbackUpdateAction' && header.visibility">
                <v-btn 
                  @click="updateCRMWhatsappConversationFeedbackIsPinned(computed_selectedCRMWhatsappConversationFeedbackCount > 0 ? null : row.item)"
                  :disabled="computed_selectedCRMWhatsappConversationFeedbackCount > 0 && !row.item.selectedCRMWhatsappConversationFeedback"
                  color="indigo" 
                  class="hoverableText"
                >
                  <v-icon size="small" style="margin-right: 10px;">mdi-check-circle</v-icon>
                  <p style="font-size: small;">MARCAR COMO LEÍDO{{ (computed_selectedCRMWhatsappConversationFeedbackCount > 1 && row.item.selectedCRMWhatsappConversationFeedback) ? 'S' : '' }}</p>
                </v-btn>
              </template>
            </td>
          </template>
        </tr>
      </template>
      <template v-slot:loading>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; padding: 30px;">
          <v-icon color="indigo" size="large" style="margin-bottom: 10px;">mdi-clock</v-icon>
          <p>Cargando lista de feedbacks...</p>
        </div>
      </template>
      <template v-slot:bottom></template>
    </v-data-table>
    <template v-if="display.CRMWhatsappConversationFeedbacksCount > 0">
      <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
      <v-card elevation="0" rounded="0" color="primary">
        <div class="footerContainer">
          <div class="footerActionsContainer">
            <template v-if="computed_selectedCRMWhatsappConversationFeedbackCount > 0">
              <p><strong>{{ computed_selectedCRMWhatsappConversationFeedbackCount }}</strong> feedback{{ computed_selectedCRMWhatsappConversationFeedbackCount > 1 ? 's' : '' }} seleccionado{{ computed_selectedCRMWhatsappConversationFeedbackCount > 1 ? 's' : '' }}</p>
              <v-btn color="indigo" class="hoverableText" @click="updateCRMWhatsappConversationFeedbackIsPinned(null)">
                <v-icon size="small" style="margin-right: 10px;">mdi-check-circle</v-icon>
                <p style="font-size: small;">MARCAR COMO LEÍDO{{ (computed_selectedCRMWhatsappConversationFeedbackCount > 1) ? 'S' : '' }}</p>
              </v-btn>
              <v-btn color="error" class="hoverableText" @click="display.CRMWhatsappConversationFeedbacks.forEach(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.selectedCRMWhatsappConversationFeedback = false); input.allCRMWhatsappConversationFeedbackSelected = false;">
                <v-icon size="small" style="margin-right: 10px;">mdi-close-circle</v-icon>
                <p style="font-size: small;">CANCELAR</p>
              </v-btn>
            </template>
          </div>
          <div class="footerPaginatorContainer">
            <v-pagination
              v-model="input.page"
              @update:model-value="selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent(false)"
              :disabled="loader.selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentPagination"
              :length="Math.ceil(display.CRMWhatsappConversationFeedbacksCount / navigation.limit)"
              :total-visible="5"
              density="compact"
              size="small"
            ></v-pagination>
            <p style="font-size: x-small;">{{ (display.CRMWhatsappConversationFeedbacksCount == 0) ? `0 de 0 feedbacks` : `${(input.page - 1) * navigation.limit + 1} - ${Math.min(input.page * navigation.limit, display.CRMWhatsappConversationFeedbacksCount)} de ${display.CRMWhatsappConversationFeedbacksCount} ${display.CRMWhatsappConversationFeedbacksCount > 1 ? 'feedbacks' : 'feedback'}`}}</p>
          </div>
        </div>
      </v-card>
    </template>
  </div>
</template>

<style scoped>
  .v-data-table th {
    padding: 0 !important;
  }
  .footerContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: 10px;
    padding: 10px;
  }
  .footerActionsContainer {
    display: flex;
    flex-direction: row;
    margin-right: auto;
    gap: 15px;
    align-items: center;
  }
  .footerPaginatorContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: auto;
  }
  @media (max-width: 1200px) {
    .footerContainer {
      grid-template-columns: repeat(1, 1fr);
    }
    .footerActionsContainer {
      margin-right: 0;
      flex-direction: column;
    }
    .footerPaginatorContainer {
      margin-left: 0;
    }
  }
  
</style>

<script>
  import websocket from '@/utilities/websocket';
  import { systemInformation } from '@/utilities/systemInformation';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => ({
      input: 
      {
        allCRMWhatsappConversationFeedbackSelected: false,
        page: 1
      },
      display: 
      {
        CRMWhatsappConversationFeedbackHeaders:
        [
          {title: 'ID', value: 'CRMWhatsappConversationFeedbackID', icon: 'mdi-barcode', index: 0, visibility: true},
          {title: 'CONTACTO', value: 'CRMWhatsappContactID', icon: 'mdi-account', index: 1, visibility: true},
          {title: 'CREACIÓN', value: 'CRMWhatsappConversationFeedbackCreationDatetime', icon: 'mdi-calendar', index: 2, visibility: true},
          {title: 'VENDEDOR', value: 'CRMAgentID', icon: 'mdi-account', index: 3, visibility: true},
          {title: 'ATENCIÓN', value: 'CRMWhatsappConversationFeedbackOne', icon: 'mdi-numeric-1-circle', index: 4, visibility: true},
          {title: 'VELOCIDAD', value: 'CRMWhatsappConversationFeedbackTwo', icon: 'mdi-numeric-2-circle', index: 5, visibility: true},
          {title: 'PRODUCTOS', value: 'CRMWhatsappConversationFeedbackThree', icon: 'mdi-numeric-3-circle', index: 6, visibility: true},
          {title: 'RECOMENDACIÓN', value: 'CRMWhatsappConversationFeedbackFour', icon: 'mdi-numeric-4-circle', index: 7, visibility: true},
          {title: 'TOTAL', value: 'CRMWhatsappConversationFeedbackTotal', icon: 'mdi-star', index: 8, visibility: true},
          {title: 'WISHLIST', value: 'CRMWhatsappConversationFeedbackSeven', icon: 'mdi-gift', index: 9, visibility: true},
          {title: 'COMENTARIO', value: 'CRMWhatsappConversationFeedbackSix', icon: 'mdi-comment', index: 10, visibility: true},
          {title: 'CONVERSACIÓN', value: 'CRMWhatsappConversationFeedbackAction', icon: 'mdi-chat', index: 11, visibility: true},
          {title: 'RETOMAR', value: 'CRMWhatsappConversationFeedbackResumeAction', icon: 'mdi-chat-plus', index: 12, visibility: true},
          {title: null, value: 'CRMWhatsappConversationFeedbackSelectAction', icon: null, index: 13, visibility: true},
          {title: 'MARCAR COMO LEÍDO', value: 'CRMWhatsappConversationFeedbackUpdateAction', icon: 'mdi-check-circle', index: 14, visibility: true}
        ],
        CRMWhatsappConversationFeedbacks: [],
        CRMWhatsappConversationFeedbacksCount: 0
      },
      navigation:
      {
        limit: 50,
        noData: false
      },
      loader:
      {
        selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent: false,
        selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentPagination: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgents: [],
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed: 
    {
      computed_selectedCRMWhatsappConversationFeedbackCount(){
        return this.display.CRMWhatsappConversationFeedbacks.slice().filter(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.selectedCRMWhatsappConversationFeedback).length;
      }
    },

    methods: {
      async selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent(isNewSearch){
        if (isNewSearch){
          this.input.page = 1;
          this.display.CRMWhatsappConversationFeedbacks.length = 0;
          this.display.CRMWhatsappConversationFeedbacksCount = 0;
          this.loader.selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent = true;
        }
        this.loader.selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentPagination = true;
        const selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'page': this.input.page,
          'limit': this.navigation.limit
        };
        const selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationFeedback/functions/selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent', selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentRequestQuery);
        if (selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentResult.success) {
          this.display.CRMWhatsappConversationFeedbacks = selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentResult.result.CRMWhatsappConversationFeedbacks.map(CRMWhatsappConversationFeedback => ({
            ...CRMWhatsappConversationFeedback,
            'selectedCRMWhatsappConversationFeedback': false,
            'loadingCRMWhatsappConversationFeedback': false,
            'appearingCRMWhatsappConversationFeedback': false
          }));
          this.display.CRMWhatsappConversationFeedbacksCount = selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentResult.result.CRMWhatsappConversationFeedbacksCount;
          this.navigation.noData = this.display.CRMWhatsappConversationFeedbacksCount == 0;
          this.loader.selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent = false;
          this.loader.selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponentPagination = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent_error', 'error', 'Ha ocurrido un error inesperado al consultar los feedbacks, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      async updateCRMWhatsappConversationFeedbackIsPinned(CRMWhatsappConversationFeedback){
        const CRMWhatsappConversationFeedbacks = CRMWhatsappConversationFeedback ? [CRMWhatsappConversationFeedback] : this.display.CRMWhatsappConversationFeedbacks.filter(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.selectedCRMWhatsappConversationFeedback);
        CRMWhatsappConversationFeedbacks.forEach(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.loadingCRMWhatsappConversationFeedback = true);
        const updateCRMWhatsappConversationFeedbackIsPinnedRequestQuery =
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          },
          'CRMWhatsappConversationFeedbackID': CRMWhatsappConversationFeedbacks.map(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.CRMWhatsappConversationFeedbackID),
          'CRMWhatsappConversationFeedbackIsPinned': false
        };
        const updateCRMWhatsappConversationFeedbackIsPinnedResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappConversation/CRMWhatsappConversationFeedback/functions/updateCRMWhatsappConversationFeedbackIsPinned', updateCRMWhatsappConversationFeedbackIsPinnedRequestQuery);
        if (updateCRMWhatsappConversationFeedbackIsPinnedResult.success) {
          this.input.allCRMWhatsappConversationFeedbackSelected = false;
          this.display.CRMWhatsappConversationFeedbacks = this.display.CRMWhatsappConversationFeedbacks.filter(CRMWhatsappConversationFeedback => !CRMWhatsappConversationFeedbacks.map(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.CRMWhatsappConversationFeedbackID).includes(CRMWhatsappConversationFeedback.CRMWhatsappConversationFeedbackID));
          this.display.CRMWhatsappConversationFeedbacksCount = this.display.CRMWhatsappConversationFeedbacksCount - CRMWhatsappConversationFeedbacks.length;
          this.navigation.noData = this.display.CRMWhatsappConversationFeedbacksCount == 0;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappConversationFeedbackIsPinned_error', 'error', 'Ha ocurrido un error inesperado al marcar al feedback como leído, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
        CRMWhatsappConversationFeedbacks.forEach(CRMWhatsappConversationFeedback => CRMWhatsappConversationFeedback.loadingCRMWhatsappConversationFeedback = false);
      },

      updateCRMWhatsappConversationFeedbackHeadersIndex(headerKey, indexChange) {
        const updatedTableHeader = this.display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == headerKey);
        const swappedTableHeader = this.display.CRMWhatsappConversationFeedbackHeaders.find(header => header.index == (this.display.CRMWhatsappConversationFeedbackHeaders.find(header => header.value == headerKey).index + indexChange));
        if (updatedTableHeader && swappedTableHeader) [updatedTableHeader.index, swappedTableHeader.index] = [swappedTableHeader.index, updatedTableHeader.index];
        const headers = this.display.CRMWhatsappConversationFeedbackHeaders.reduce((headers, header) => {headers[header.value] = header.index; return headers;}, {});
        localStorage.setItem('CRMDashboardCRMWhatsappConversationFeedbacksView_CRMWhatsappConversationFeedbackHeaders', JSON.stringify(headers));      
      },

      updateCRMWhatsappConversationFeedbackHeadersVisibility(){
        localStorage.setItem('CRMDashboardCRMWhatsappConversationFeedbacksView_CRMWhatsappConversationFeedbackHeaders', JSON.stringify(this.display.CRMWhatsappConversationFeedbackHeaders));      
      },

      async prepareTable() {
        let headersVisibility;
        try { headersVisibility = JSON.parse(localStorage.getItem('CRMDashboardCRMWhatsappConversationFeedbacksView_CRMWhatsappConversationFeedbackHeaders')); }
        catch { headersVisibility = null; }
        for (const headerIndex in headersVisibility){
          const headerVisibility = headersVisibility[headerIndex];
          if (this.display.CRMWhatsappConversationFeedbackHeaders.find(header => header.index == headerIndex)) this.display.CRMWhatsappConversationFeedbackHeaders.find(header => header.index == headerIndex).visibility = headerVisibility.visibility 
        }
        let headersIndex;
        try { headersIndex = JSON.parse(localStorage.getItem('CRMDashboardCRMWhatsappConversationFeedbacksView_CRMWhatsappConversationFeedbackHeaders')); }
        catch { headersIndex = null; }
        this.display.CRMWhatsappConversationFeedbackHeaders = this.display.CRMWhatsappConversationFeedbackHeaders.map(header => ({ ...header, index: headersIndex?.[header.value] ?? Infinity })).sort((headerA, headerB) => headerA.index - headerB.index).map((header, i) => ({ ...header, index: i }));
        this.loader.getSystemInformation = false;
      },

      async getSystemInformationData(){
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgents = systemInformation.getCRMAgents;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      },

      handleWebsocket(){
        websocket.connectWebsocket();

        websocket.addWebsocketMessageListener('/CRMWhatsappConversation/CRMWhatsappConversationFeedback/functions/generateCRMWhatsappConversationFeedback_CRMDashboard', 
          async (websocketMessageData) => {
            const newCRMWhatsappConversationFeedback = 
            {
              ...websocketMessageData.websocketMessageContent,
              'CRMWhatsappConversationFeedbackCreationDatetime': new Date(),
              'loadingCRMWhatsappConversationFeedback': false,
              'appearingCRMWhatsappConversationFeedback': true,
              'selectedCRMWhatsappConversationFeedback': false
            };  
            this.display.CRMWhatsappConversationFeedbacks.unshift(newCRMWhatsappConversationFeedback);
            setTimeout(() => {
              const CRMWhatsappConversationFeedback = this.display.CRMWhatsappConversationFeedbacks.find(displayCRMWhatsappConversationFeedback => displayCRMWhatsappConversationFeedback.CRMWhatsappConversationFeedbackID == newCRMWhatsappConversationFeedback.CRMWhatsappConversationFeedbackID);
              if (CRMWhatsappConversationFeedback) CRMWhatsappConversationFeedback.appearingCRMWhatsappConversationFeedback = false;
            }, 1000);
          }
        );
      },
    },  

    async mounted() {
      await this.prepareTable();
      await this.getSystemInformationData();
      this.selectCRMWhatsappConversationFeedbackFromCRMDashboardCRMWhatsappConversationFeedbacksComponent(true);
      this.handleWebsocket();
    }
  }
</script>